import React from 'react';
import { services } from './homeContent';
import { ContactLink, ServiceIcon } from './HomeUI';

export default function SectionTwo({ onExplore }) {
  return <section id="home-services" className="home-section">
    <div className="home-container">
      <div className="home-section-heading">
        <p className="home-eyebrow">Our services</p>
        <h2>The right solution.<br /><span>The right team to build it.</span></h2>
        <p>Comprehensive technology services for a single business or a portfolio of companies. We bring together experienced engineers, designers, and delivery specialists around the problem you need to solve.</p>
      </div>
      <div className="home-service-grid">
        {services.map(service => <article key={service.title} className="home-service-card">
          <span className="home-icon"><ServiceIcon name={service.icon} /></span>
          <h3>{service.title}</h3>
          <p>{service.description}</p>
          <button className="home-card-link" onClick={() => onExplore(service.journey)}>Explore the process <span className="home-sr-only">for {service.title}</span><span aria-hidden="true">→</span></button>
        </article>)}
      </div>
      <div className="home-inline-cta"><p>Not sure where to start? Let’s understand the opportunity together.</p><ContactLink>Start a conversation</ContactLink></div>
    </div>
  </section>;
}
